export const API_TEST_URL = "https://3xg4g3zxg2.execute-api.us-east-1.amazonaws.com/test";
export const esEntornoTest = import.meta.env?.VITE_STAGE === "test";

export function validarApiTest(stage, url) {
  if (stage === "test" && url !== API_TEST_URL) {
    throw new Error("El ambiente Test requiere su API Test explícita.");
  }
  return url;
}
